export default {
  // Document titles
  'quotation.preliminary': 'Preliminary Quotation',
  'quotation.finalOffer': 'Final Offer',

  // Meta
  'quotation.quoteNumber': 'Quote Number',
  'quotation.offerNumber': 'Offer Number',
  'quotation.status': 'Status',
  'quotation.createdDate': 'Created Date',
  'quotation.quoteType': 'Quote Type',
  'quotation.quoteCurrency': 'Quote Currency',
  'quotation.issuedDate': 'Issue Date',
  'quotation.validUntil': 'Valid Until',
  'quotation.reference': 'Related Preliminary Quote',

  // Sections
  'quotation.buyerInfo': 'Buyer Information',
  'quotation.products': 'Products',
  'quotation.finishing': 'Finishing / Decoration',
  'quotation.printing': 'Printing',
  'quotation.specialRequirements': 'Special Requirements',
  'quotation.pricingSummary': 'Pricing Summary',
  'quotation.commercialCharges': 'Commercial Charges',
  'quotation.commercialTerms': 'Commercial Terms',

  // Pricing rows
  'quotation.productSubtotal': 'Product Subtotal',
  'quotation.finishingSubtotal': 'Finishing Subtotal',
  'quotation.preliminaryTotal': 'Preliminary Total',
  'quotation.preliminaryQuoteTotal': 'Preliminary Quote Total',
  'quotation.finalTotal': 'Final Total',

  // Commercial charges
  'quotation.freight': 'Freight',
  'quotation.insurance': 'Insurance',
  'quotation.customsClearance': 'Customs Clearance',
  'quotation.duty': 'Duty',
  'quotation.tax': 'Tax / VAT / GST',
  'quotation.manualAdjustment': 'Manual Adjustment',
  'quotation.discount': 'Discount',

  // Commercial terms
  'quotation.paymentTerms': 'Payment Terms',
  'quotation.leadTime': 'Lead Time',
  'quotation.deliveryTerms': 'Delivery Terms',
  'quotation.incoterms': 'Incoterms',
  'quotation.commercialNotes': 'Commercial Notes',

  // Product detail fields
  'quotation.quantity': 'Quantity',
  'quotation.unitPrice': 'Unit Price',
  'quotation.amount': 'Amount',
  'quotation.sku': 'SKU',
  'quotation.material': 'Material',
  'quotation.capacity': 'Capacity',
  'quotation.specification': 'Specification',

  // Buyer fields
  'quotation.companyName': 'Company Name',
  'quotation.contactPerson': 'Contact Person',
  'quotation.country': 'Country',
  'quotation.address': 'Address',
  'quotation.email': 'Email',
  'quotation.phone': 'Phone',

  // PDF
  'quotation.pdfView': 'View PDF',
  'quotation.pdfDownload': 'Download PDF',
  'quotation.pdfGenerating': 'Generating PDF...',
  'quotation.pdfError': 'Could not generate the PDF. Please try again.',
  'quotation.pdfClose': 'Close',
  'quotation.pdfOpenNewTab': 'Open in new tab',
  'quotation.pdfLoading': 'Loading PDF...',
  'quotation.pdfLoadError': 'Unable to load this PDF.',
  'quotation.pdfLoadErrorHint': 'Please try again.',
  'quotation.pdfRetry': 'Retry',
  'quotation.pdfFitWidth': 'Fit Width',
  'quotation.pdfZoomIn': 'Zoom In',
  'quotation.pdfZoomOut': 'Zoom Out',

  // Quote type
  'quotation.type.production': 'Production',
  'quotation.type.sample': 'Sample',
};